<template>
  <v-container>
    <h4>Supplier list</h4>
    <v-row
        v-for="(item, i) in supplier_list"
        :key="i"
      >
        <v-col
          cols="1"
        >
          {{ i+1 }}
        </v-col>
        <v-col
          cols="9"
        >
          {{ item.name }}
          <br/>
          <small>Branch: {{ item.branch }}</small>
        </v-col>
        <v-col
          cols="2"
        >
          <v-checkbox
            v-model="item.selected"
            :value="item.selected"
            label="Select"
          />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: 'SupplierList',
  components: { },
  props: ['supplier_list', 'suppliers'],
  data: () => ({ }),
  async mounted () {
    await this.getSupplierList();
  },
  methods: {
    async getSupplierList () {
      try {
        const { data } = await this.$http.get('/back-office/suppliers', authHeader())
        for (let supplier of data) {
          this.supplier_list.push({
            id: supplier.id,
            name: supplier.name,
            branch: supplier.branch,
            selected: false
          });
        }
        if (this.suppliers && this.suppliers.length) {
          for (let supplier of this.supplier_list) {
            let element = this.suppliers.find(element => element.id == supplier.id)
            if (element) {
              supplier.selected = true
            }
          }
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
  }
}
</script>